export default {
      id: "sites-usage",
      viewBox: "0 0 30 30",
      url: __webpack_public_path__ + "sprite.svg#sites",
      toString: function () {
        return this.url;
      }
    }